<script setup lang="ts">
// A slice of Ava's mychar.gg page for the landing mocks: her background photo,
// dimmed the way a real page sits under its cards, with her accent colour as
// the primary colour inside (.mock-page in main.css). Put .mock-card /
// .mock-embed surfaces in the slot. Light mode shows her light page theme.
withDefaults(defineProps<{
  /** Background photo (MockPhoto name) */
  bg?: string
  /** CSS object-position of the background, to show a different part per mock */
  bgPosition?: string
}>(), { bg: 'page-bg', bgPosition: '50% 50%' })
</script>

<template>
  <div class="mock-page relative isolate overflow-hidden">
    <MockPhoto
      :name="bg"
      :position="bgPosition"
      class="-z-10"
    />
    <div class="absolute inset-0 -z-10 bg-(--mock-page-dim)" />
    <slot />
  </div>
</template>
